module.exports = __webpack_public_path__ + "static/media/IMG_0876.9fb77ec1.jpg";